// extracted by mini-css-extract-plugin
module.exports = {"alert-icon":"alert-dialog_component_alert-icon__7tmpi","footer-btn":"alert-dialog_component_footer-btn__SOaTi"};